export const ScheduledMaintenanceRoutes = {
    BaseUrl: "ScheduledMaintenance/",
    GetNextScheduledMaintenance: "ScheduledMaintenance/GetNextScheduledMaintenance/",
    CompleteScheduledMaintenance: "ScheduledMaintenance/CompleteScheduledMaintenance/",
    ForceStart: "ScheduledMaintenance/ForceStart/"
}

